<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/useAuth'

const router = useRouter()
const auth = useAuth()

definePage({
  meta: {
    requiresAuth: true,
  },
})

onMounted(async () => {
  if (!auth.initialized.value) {
    await auth.initialize()
  }

  if (!auth.isAuthenticated.value) {
    await router.replace('/login')
    return
  }

  await router.replace('/admin')
})
</script>

<template>
  <div class="min-vh-100 d-flex align-items-center justify-content-center text-muted">
    Redirecionando…
  </div>
</template>
